import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito experiencia previa en mecánica?',
  a: 'No. El sistema está diseñado para llevarte desde cero absoluto hasta un nivel profesional usando nuestro método de Lógica de Taller.'
}, {
  q: '¿Necesito herramientas costosas para empezar?',
  a: 'Para nada. Te enseñamos a realizar los primeros trabajos con herramientas básicas que podés tener en tu casa. Con tus primeras ganancias vas a poder equiparte mejor.'
}, {
  q: '¿El curso sirve para cualquier tipo de moto?',
  a: 'Sí. Al entender la lógica del motor y los sistemas, vas a poder trabajar desde motos 110cc hasta unidades de alta cilindrada e inyección electrónica.'
}, {
  q: '¿Cómo accedo al contenido después de pagar?',
  a: 'El acceso es inmediato. Una vez confirmado el pago, recibís un mail con tus credenciales para entrar a la plataforma y empezar a ver las 265 clases hoy mismo.'
}, {
  q: '¿Realmente hay salida laboral rápida?',
  a: 'Sí. Argentina tiene una demanda crítica de mecánicos. Te enseñamos las reparaciones de mayor rotación para que puedas generar ingresos en tus primeras semanas.'
}, {
  q: '¿Qué pasa si tengo dudas durante el curso?',
  a: 'Tendrás acceso a nuestra comunidad privada de alumnos para consultar casos reales y recibir soporte de otros colegas y profesionales.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-slate-950 px-4" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <h2 className="text-3xl font-bold text-white text-center mb-12 uppercase" data-id="element-23">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-24">
          {FAQS.map((faq, idx) => <div key={idx} className="border border-slate-800 rounded-lg bg-slate-900/50 overflow-hidden" data-id="element-25">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-4 text-left hover:bg-slate-800/50 transition-colors" data-id="element-26">
                <span className="font-bold text-slate-200" data-id="element-27">{faq.q}</span>
                {openIndex === idx ? <ChevronUp className="text-orange-500" data-id="element-28" /> : <ChevronDown className="text-slate-500" data-id="element-29" />}
              </button>
              {openIndex === idx && <div className="p-4 pt-0 text-slate-400 border-t border-slate-800/50 bg-slate-900/30" data-id="element-30">
                  <p className="mt-2" data-id="element-31">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}